export const ROLES = {
    all: 'all',
    admin: 'admin',
    driver: 'driver',
    customer: 'customer',
    seoAdmin: 'seo_admin',
};
